import { ComponentProps } from 'lib/ComponentProps';

import ChevronRightIconSvg from 'public/icons/ChevronRight.svg';

import styles from './Breadcrumbs.module.css';

type BreadcrumbProps = ComponentProps & {
	fields: {
		Breadcrumbs: {
			Url: string;
			Name: string;
		}[];
	};
};

export default function Breadcrumbs(props: BreadcrumbProps): JSX.Element {
	if (!props.fields) {
		return <></>;
	}

	const breadcrumbContent = (isFirst: boolean, name: string) => {
		return (
			<>
				{!isFirst && <ChevronRightIconSvg className={styles.chevron} />}
				<span>{name}</span>
			</>
		);
	};

	return (
		<div className={`${styles.header} ${styles.flex} maxWidth`}>
			{props.fields.Breadcrumbs.map((breadcrumb, index) => {
				return index === props.fields.Breadcrumbs.length - 1 ? (
					<span key={breadcrumb.Name} className={`${styles.lastCrumb} ${styles.flex}`}>
						{breadcrumbContent(index === 0, breadcrumb.Name)}
					</span>
				) : (
					<a key={breadcrumb.Name} href={breadcrumb.Url} className={`${styles.breadcrumb} ${styles.flex}`}>
						{breadcrumbContent(index === 0, breadcrumb.Name)}
					</a>
				);
			})}
		</div>
	);
}
